<template>
  <!-- wrapper span allows you to apply different text-transform modes -->
  <span
    class="text-format"
    :class="computedClass"
  >
    <slot></slot>
  </span>
</template>

<script>
export default {
  name: "CapitalizeFirst",
  props: {
    /**
     * mode options:
     *  - 'first' → only first letter uppercase (default)
     *  - 'textUppercase' → all letters uppercase
     *  - 'textLowercase' → all letters lowercase
     */
    mode: {
      type: String,
      default: "first",
      validator: val => ["first", "textUppercase", "textLowercase"].includes(val)
    }
  },
  computed: {
    computedClass() {
      if (this.mode === 'textUppercase') return 'text-textUppercase';
      if (this.mode === 'textLowercase') return 'text-textLowercase';
      return 'textCapFirst';
    }
  }
};
</script>

<style scoped>

</style>
